import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';
// Remove direct GA. Use GTM dataLayer events instead.

// Custom hook for Google Analytics
export const useAnalytics = () => {
  const location = useLocation();

  // No GA init

  useEffect(() => {
    // Push SPA page_view into dataLayer for GTM to handle
    if (typeof window !== 'undefined' && location.pathname) {
      const path = location.pathname + (location.search || '');
      // Derive a descriptive page title per route to avoid all views lumping under a single title
      const routeToTitle = (pathname) => {
        if (pathname === '/' || pathname.startsWith('/home')) return 'Home';
        if (pathname.startsWith('/settings')) return 'Settings';
        if (pathname.startsWith('/organizations')) return 'Organizations';
        if (pathname.startsWith('/api-keys')) return 'API Keys';
        if (pathname.startsWith('/policy-configuration')) return 'Policy Configuration';
        if (pathname.startsWith('/configurations')) return 'Available Organizations';
        if (pathname.startsWith('/available-rules')) return 'Available Rules';
        if (pathname.startsWith('/billing') || pathname.startsWith('/subscription')) return 'Subscription & Billing';
        if (pathname.startsWith('/pricing')) return 'Pricing';
        if (pathname.startsWith('/invite-users')) return 'Add Collaborators';
        if (pathname.startsWith('/my-collaborations')) return 'Organization Collaborations';
        if (pathname.startsWith('/investigation')) return 'Advanced Search';
        if (pathname.startsWith('/users')) return 'User Lookup';
        if (pathname.startsWith('/activity')) return 'Activity';
        if (pathname.startsWith('/dashboard')) return 'Overview';
        // Fallback
        return 'Home';
      };
      const pageTitle = routeToTitle(location.pathname) || 'Home';
      // Always set a descriptive title before tracking; avoid duplicate defaults
      const finalTitle = `${pageTitle} • Bespot Gatekeeper`;
      document.title = finalTitle;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_view',
        page_path: path,
        page_title: finalTitle,
        page_location: window.location.href,
      });

      // PostHog pageview
      if (posthog?.capture) {
        posthog.capture('$pageview', { path, title: finalTitle });
      }
    }
  }, [location]);
};

export default useAnalytics;
